import { ROLES, STANDARD_PROFILES } from '@savgroup-front-common/constants';

import { useCurrentUser } from '../domains/login/useLoginStore';

import useHasProfile from './useHasProfile';

const useActiveRole = () => {
  const { roles } = useCurrentUser();

  return roles;
};

const hasRole = (roles?: ROLES[], check?: ROLES) =>
  (roles || []).some((role) => check === role);

export function useHasRole(role: ROLES) {
  const accesses = useActiveRole();

  return hasRole(accesses, role);
}

export function useHasEveryRoles(roles: ROLES[]) {
  const accesses = useActiveRole();

  return roles.every((role) => hasRole(accesses, role));
}

export function useHasSomeRoles(roles: ROLES[]) {
  const accesses = useActiveRole();

  return roles.some((role) => hasRole(accesses, role));
}

export const useIsSuperAdmin = () => {
  const hasSuperAdminProfile = useHasProfile(STANDARD_PROFILES.SUPER_ADMIN);

  /** @deprecated: SuperAdmin role is replaced with Standard SuperAdmin profile */
  const hasSuperAdminRole = useHasRole(ROLES.SUPER_ADMIN);

  return hasSuperAdminProfile ?? hasSuperAdminRole;
};

export const useIsAdmin = () => {
  return useHasSomeRoles([ROLES.SUPER_ADMIN, ROLES.ACCOUNT_MANAGER]);
};
